'use strict';
import {Subject} from 'rxjs/Subject';
const angular = require('angular');
const {forEach, isDefined, isObject, isString, lowercase, toJson} = angular;
const toString = Object.prototype.toString;

module.exports = [
  '$provide',
  HttpDecorator];

function HttpDecorator($provide) {
  $provide.decorator('$http', [
    '$delegate',
    decorateHttpService]);

  function decorateHttpService(
    $delegate,
  ) {
    $delegate.upload = uploadFile;
    return $delegate;

    function uploadFile(config) {
      var deferred = Promise.defer();
      var progress$ = new Subject();
      deferred.promise.then(function () {
        progress$.complete();
        setTimeout(progress$.unsubscribe.bind(progress$), 150); // make sure this is cleaned up. may not be necessary
      }, function () {
        progress$.error();
        setTimeout(progress$.unsubscribe.bind(progress$), 150); // make sure this is cleaned up. may not be necessary
      });
      var xhr = new XMLHttpRequest();

      xhr.open(config.method, config.url, true);
      forEach(config.headers, function (value, key) {
        if (isDefined(value)) {
          xhr.setRequestHeader(key, value);
        }
      });

      // onload handler is largely copied from Angular's $httpBackend implementation to include all of the vendor-specific handling Angular $http normally supports
      xhr.onload = function (e) {
        //console.log('custom upload completed with result', e);

        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        //if (status === 0) {
        //  status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
        //}


        resolvePromise(
          response,
          status,
          xhr.getAllResponseHeaders(),
          statusText);
      };

      xhr.onerror = deferred.reject.bind(deferred);

      xhr.upload.onprogress = progress$.next.bind(progress$);

      xhr.send(isObject(config.data) && !isFile(config.data) && !isBlob(config.data) && !isFormData(config.data) ? toJson(config.data) : config.data || null);

      return {
        promise: deferred.promise,
        observable: progress$
      };

      function resolvePromise(response, status, headers, statusText) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;
        let result = {
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText
        };

        if (isSuccess(status)) {
          deferred.resolve(result);
        } else {
          deferred.reject(result);
        }
      }
    }
  }

  // Helper methods are copied from $httpBackend since they are not exposed by any API...

  /**
   * Returns a function that provides access to parsed headers.
   *
   * Headers are lazy parsed when first requested.
   * @see parseHeaders
   *
   * @param {(string|Object)} headers Headers to provide access to.
   * @returns {function(string=)} Returns a getter function which if called with:
   *
   *   - if called with single an argument returns a single header value or null
   *   - if called with no arguments returns an object containing all headers.
   */
  function headersGetter(headers) {
    var headersObj;

    return function (name) {
      if (!headersObj) headersObj = parseHeaders(headers);

      if (name) {
        var value = headersObj[lowercase(name)];
        if (value === void 0) {
          value = null;
        }
        return value;
      }

      return headersObj;
    };
  }

  /**
   * Parse headers into key value object
   *
   * @param {string} headers Raw headers as a string
   * @returns {Object} Parsed headers as key value object
   */
  function parseHeaders(headers) {
    var parsed = {}, i;

    function fillInParsed(key, val) {
      if (key) {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }

    if (isString(headers)) {
      forEach(headers.split('\n'), function (line) {
        i = line.indexOf(':');
        fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
      });
    } else if (isObject(headers)) {
      forEach(headers, function (headerVal, headerKey) {
        fillInParsed(lowercase(headerKey), trim(headerVal));
      });
    }

    return parsed;
  }

  function isSuccess(status) {
    return 200 <= status && status < 300;
  }
}


// Type Test Methods below copied from angular source as they are not exposed in the API but required for correct XHR2 payload handling.

function isFile(obj) {
  return toString.call(obj) === '[object File]';
}

function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}

function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/$httpDecorator.js